import { FC, PropsWithChildren } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

const BestEffortFallback: FC<FallbackProps> = ({ error }) => {
  console.log(error.message);

  return <></>;
};

export const withBestEffort = (Component: FC<any>): FC<any> => {
  const WrappedComponent: FC<any> = props => {
    return <ErrorBoundary FallbackComponent={BestEffortFallback}>{<Component {...props} />}</ErrorBoundary>;
  };

  return WrappedComponent;
};
